import { NgModule } from '@angular/core';
import { DictionaryRoutesHostsResourceService } from "libraries/service/resources/dictionary-routes-hosts/dictionary-routes-hosts-resource.service";
import { ApiResourceModule } from "../../apiResource/apiResource.module";


@NgModule({
    imports: [
        ApiResourceModule,
    ],

    providers: [
        DictionaryRoutesHostsResourceService
    ],
})
export class DictionaryRoutesHostsRessourceModule {
}
